export function RequestinProcess(in_process){
  // console.log('RequestinProcess');
  return {
        type: "ToogleRequestProccess",
        payload: in_process
    };
}
export function AddPaginationURL(model_event,payload){
  return {
        type: model_event,
        payload: payload
    };
}
export function SuperADODB(model_event,payload){
  return {
        type: model_event,
        payload: payload
    };
}
export function Exec(model_event,payload){
  return {
        type: model_event,
        payload: payload
    };
}



// WEBPACK FOOTER //
// ./src/App/helper/request.action.js